import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { isMobileOnly } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import $ from "jquery";
import Whatsapp from "../assets/social/whatsapplogo.png";

const Header = (props) => {
  const [activeModal, setActiveModal] = useState(false);
  var { pathname } = useLocation();

  const headerRef = useRef();
  const scrollHandle = (event) => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 0) {
      headerRef.current.classList.add("scrolled");
    } else {
      headerRef.current.classList.remove("scrolled");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollHandle);
    return function () {
      window.removeEventListener("scroll", scrollHandle);
    };
  }, []);
  const MenuClose = () => {
    setTimeout(function () {
      if ($(".menu-side-img.overlay-burger").is(":visible")) {
        $("button.toggle-nav.is-active").removeClass("darkclose");
      } else {
        $("button.toggle-nav.is-active").addClass("darkclose");
      }
    }, 1000);
  };

  const goToTop = () => {
    window.scrollTo(0,0)
  }
  return (
    <>
      <nav className='website' ref={headerRef}>
        <div className='header'>
          <Container fluid>
            <Row className="head--row">
              {!isMobileOnly ? (
                <>
                  <Col lg='4' md='3'>
                    <h4>
                      <Link to='/' className='myName' onClick={() => goToTop()}>
                        Makeshwaran M
                      </Link>
                    </h4>
                  </Col>
                  <Col lg='7' md='9'>
                    <div className='menu-list'>
                      <ul className='list'>
                        <Link to='/' onClick={() => goToTop()}>
                          <li className={pathname === "/" ? "active" : ""}>
                            Home
                          </li>
                        </Link>
                        <Link to='/education' onClick={() => goToTop()}>
                          <li
                            className={
                              pathname === "/education" ? "active" : ""
                            }>
                            Education
                          </li>
                        </Link>
                        <Link to='/experience' onClick={() => goToTop()}>
                          <li
                            className={
                              pathname === "/experience" ? "active" : ""
                            }>
                            Experience
                          </li>
                        </Link>
                        <Link to='/projects' onClick={() => goToTop()}>
                          <li
                            className={
                              pathname === "/projects" ? "active" : ""
                            }>
                            Projects
                          </li>
                        </Link>
                        <Link to='/contact' onClick={() => goToTop()}>
                          <li
                            className={pathname === "/contact" ? "active" : ""}>
                            Contact
                          </li>
                        </Link>
                      </ul>
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <h4>
                    <Link to='/' className='myName'>
                      Makeshwaran M
                    </Link>
                  </h4>
                  <button
                    className={classNames("toggle-nav", {
                      "is-active": activeModal,
                    })}
                    onClick={() => {
                      setActiveModal(!activeModal);
                      MenuClose();
                      document
                        .querySelectorAll("body,html")
                        .forEach((item) => item.classList.toggle("overflow"));
                    }}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                </>
              )}
            </Row>
            {activeModal && (
              <div className='mob-menu'>
                <ul className='list'>
                  <Link to='/'>
                    <li className={pathname === "/" ? "active" : ""}>Home</li>
                  </Link>
                  <Link to='/education'>
                    <li className={pathname === "/education" ? "active" : ""}>
                      Education
                    </li>
                  </Link>
                  <Link to='/experience'>
                    <li className={pathname === "/experience" ? "active" : ""}>
                      Experience
                    </li>
                  </Link>
                  <Link to='/projects'>
                    <li className={pathname === "/projects" ? "active" : ""}>
                      Projects
                    </li>
                  </Link>
                  <Link to='/contact'>
                    <li className={pathname === "/contact" ? "active" : ""}>
                      Contact
                    </li>
                  </Link>
                </ul>
              </div>
            )}
          </Container>
        </div>
      </nav>
      <div className='whatsapp'>
        <a
          href='https://api.whatsapp.com/send?phone=+918220387103&text=Hello%21%21%21%20Makesh%20I%20need%20your%20help%21%21%21'
          target={"_blank"}
          rel='noreferrer'>
          <img src={Whatsapp} alt='whatsapp' />
        </a>
      </div>
    </>
  );
};
export default Header;
